import axios from "./axios";

export const getNotifications = async (user) => {
    if (!user) {
        return;
    }
    try {
        const token = await user.getIdToken();
        const config = {
            headers: {Authorization: `Bearer ${token}`, mode: "no-cors", 'Access-Control-Allow-Origin': "*"},
        };
        const res = await axios.get("/notifications", config);
        return res.data;
    } catch (err) {
        console.log(err);
    }
}